import { Box, Heading, Section, Stack, Text } from "@vinomofo/components";

import kombi from "../../images/wine-clubs/kombi.svg";
import starOutline from "../../images/wine-clubs/star-outline.svg";
import star from "../../images/wine-clubs/star.svg";

const FiveStars = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mb="10px">
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
    </Box>
  );
};

const FourStars = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mb="10px">
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={star} width="26" height="26" alt="" />
      <img src={starOutline} width="26" height="26" alt="" />
    </Box>
  );
};

export const QuotesPanel = (): JSX.Element => {
  return (
    <Section pt={60} backgroundColor="almostWhite">
      <Stack space={5}>
        <Stack space={3}>
          <Heading as="h2" variant="xl" textAlign="center">
            So what do our mofos think?
          </Heading>
          <Text textAlign="center">
            We could talk about how great the club is for hours but it’s better
            hearing it from the horse’s mouth. Not that we think of our mofos as
            horses. If anything, they’re unicorns. Beautiful, merry unicorns
            with cellars full of wine.
          </Text>
        </Stack>

        <Box
          display="grid"
          gridGap={4}
          gridAutoFlow={["row", "column"]}
          justifyContent="center"
        >
          <Box as="figure" textAlign="center">
            <FiveStars />
            <Text as="blockquote" fontSize="14px">
              I’m assuming a 5 is the highest rating one can give? If so I’d
              give a 5 to the Mofo site and team.
            </Text>
            <Text
              as="cite"
              textTransform="uppercase"
              color="text.heading"
              fontSize="14px"
            >
              - Paul
            </Text>
          </Box>
          <Box as="figure" textAlign="center">
            <FiveStars />
            <Text as="blockquote" fontSize="14px">
              Set and forget, once every 3 months I get a set of fabulous,
              unique wines sent to my door. Takes all the effort out of
              choosing. Cheers Vinomofo
            </Text>
            <Text
              as="cite"
              textTransform="uppercase"
              color="text.heading"
              fontSize="14px"
            >
              - Michael
            </Text>
          </Box>
          <Box as="figure" textAlign="center">
            <FourStars />
            <Text as="blockquote" fontSize="14px">
              Consistently good wine (haven’t had a bad one yet!), prompt
              service, easily navigable site. Thank you!
            </Text>
            <Text
              as="cite"
              textTransform="uppercase"
              color="text.heading"
              fontSize="14px"
            >
              - J Garnier
            </Text>
          </Box>
        </Box>
      </Stack>

      <Box
        as="img"
        mt={["50px", "100px"]}
        mx="auto"
        width="70%"
        maxWidth="520px"
        display="block"
        opacity={0.75}
        src={kombi}
        alt=""
      />
    </Section>
  );
};
